import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from '@chakra-ui/react';
import { forwardRef, useCallback, useMemo } from 'react';
import { useHighlight } from '../../../contexts/field-highlighter';
const AuthorChip = ({ author }) => {
    const at = new Date(author.at);
    const when = isNaN(at.getTime())
        ? ''
        : at.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
    return (_jsx(Text, { as: "span", fontSize: "xs", opacity: 0.75, px: "1.5", whiteSpace: "nowrap", "data-jaen-field-author": author.sub, children: [author.name, when].filter(Boolean).join(', ') }));
};
export const HighlightTooltip = forwardRef(({ id, actions, author, as, asProps, asAs, isEditing, children, ...props }, ref) => {
    const tooltipButtons = useMemo(() => author
        ? [
            ...actions,
            _jsx(AuthorChip, { author: author }, `jaen-field-author-${id}`)
        ]
        : actions, [actions, author, id]);
    const { ref: highlightRef } = useHighlight({ tooltipButtons });
    const setRefs = useCallback((node) => {
        if (typeof ref === 'function') {
            ref(node);
        }
        else {
            if (ref)
                ref.current = node;
        }
        highlightRef(node);
    }, [ref, highlightRef]);
    const Wrapper = as || Box;
    const memoedChildren = useMemo(() => {
        if (typeof children === 'function') {
            return children({ id, ref: setRefs, tabIndex: isEditing ? 1 : undefined });
        }
        return children;
    }, [setRefs, isEditing, children]);
    if (typeof children === 'function') {
        return (_jsx(Wrapper, { ...props, ...asProps, ref: setRefs, tabIndex: isEditing ? 1 : undefined, as: asAs, id: id, _focus: {
                outline: 'none'
            }, children: memoedChildren }));
    }
    return (_jsx(Wrapper, { ...props, ...asProps, ref: setRefs, as: asAs, id: id, tabIndex: isEditing ? 1 : undefined, _focus: {
            outline: 'none'
        }, children: memoedChildren }));
});
